export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0xbAbbE203727f8327106e6087f075F2B2F2B738d1",
  capRiskStewardFactory: "0x805C408e8afAbb4D44b39B838F0586617993043a",
  edgeFactory: "0x5aECa7B7bDD4C876ed88E33Da7bAd45CB7224B12",
  edgeFactoryPerspective: "0x990Bb5D21Cc852687bF95B850a279daF9b6C45D2",
  escrowedCollateralPerspective: "0x413Cf25A789784e07a428D7fb1e0B43eeF84A4B0",
  eulerEarnFactoryPerspective: "0x3E6AEb84434F43C550F72d8F20982fC76a1A4b82",
  eulerEarnGovernedPerspective: "0x16F187C4EFCCbbF5B530A9c64447B89c4D73F3F2",
  eulerEarnPublicAllocator: "0x68a823a484a9D5A8daBB55c4d4d8006a45E557A9",
  eulerUngoverned0xPerspective: "0xeEF6CF66abbD88fe97BeE236aac21285158f3a3A",
  eulerUngovernedNzxPerspective: "0xcAb8bBe881a13A513770746AF15F7cC884843734",
  evkFactoryPerspective: "0x5A2164C500f4FD26AB037d97A3ed5d0774446c6B",
  externalVaultRegistry: "0xC0a8dFA92CB9FF9F503803D3bAE2CF19E9c15411",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0x87BeecC6B609723B2Ef071c20AA756846969240C",
  feeFlowControllerUtil: "0xfAfc7B37d6389919e5142c8b63203602Cb2a5a92",
  fixedCyclicalBinaryIRMFactory: "0x6725657eCF5f7Cc46D1E848376b4dB92D71D0d96",
  governedPerspective: "0x44d781D9f61649fACeeEC919c71C8537531df027",
  governorAccessControlEmergencyFactory:
    "0x4F74dEd1980096C44B5fEE2A697B4B05AC75d987",
  irmRegistry: "0x01315b1fa7e8A58D641C2c7f538654Fa32E0341f",
  kinkIRMFactory: "0x34f3Ecd35E05b0554B6F4ee5Ba3A373ADd6a2538",
  kinkyIRMFactory: "0x80594D095B69C7E8AC4B9fc00da59e0504C3b9f5",
  oracleAdapterRegistry: "0xDc0D3E9119d4ccB7E186E699d1df5cDd7bCa5783",
  oracleRouterFactory: "0xE551288F0D82C10bBF517DBA66E15C60BF87FE8f",
  swapVerifier: "0x7eaf8C22480129E5D7426e3A33880D7bE19B50a7",
  swapper: "0x319E8ecd3BaB57fE684ca1aCfaB60c5603087B3A",
  termsOfUseSigner: "0xEfd9F447b35aF280110975BCFA442050EF283D86",
} as const
